// import { gsap } from 'gsap';

if (document.querySelector('.text-sec__tech-row')) {
  document.querySelectorAll('.text-sec__tech-row').forEach((row) => {
    const track = row.querySelector('.text-sec__tech-row-track');
    const content = track.querySelector('.text-sec__tech-row-content');

    for (let i = 0; i < 4; i++) {
      const clone = content.cloneNode(true);
      track.appendChild(clone);
    }

    requestAnimationFrame(() => {
      const totalWidth = content.offsetWidth;

      gsap.set(track, { x: -window.innerWidth });

      gsap.to(track, {
        x: `${-1 * totalWidth}px`,
        duration: window.innerWidth > 640 ? 45 : 80,
        ease: 'none',
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize(gsap.utils.wrap(-totalWidth, 0)),
        },
      });
    });
  });
}
